export const CalendarIcon = ({ className, color = "currentColor", size = 18 }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 22.933 20.117"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(0.25 0.25)">
        {/* Rectángulo principal del calendario */}
        <path
          d="M-1.537-2H19.97a.463.463,0,0,1,.463.463V15.57a.463.463,0,0,1-.463.463H-1.537A.463.463,0,0,1-2,15.57V-1.537A.463.463,0,0,1-1.537-2Zm21.045.925H-1.075V15.107H19.507Z"
          transform="translate(2 3.585)"
          fill={color}
        />
        <path
          d="M-1.537-2.25H19.97a.713.713,0,0,1,.713.713V15.57a.713.713,0,0,1-.713.713H-1.537a.713.713,0,0,1-.713-.713V-1.537A.713.713,0,0,1-1.537-2.25ZM19.97,15.782a.213.213,0,0,0,.213-.213V-1.537a.213.213,0,0,0-.213-.213H-1.537a.213.213,0,0,0-.213.213V15.57a.213.213,0,0,0,.213.213ZM-1.075-1.325H19.507a.25.25,0,0,1,.25.25V15.107a.25.25,0,0,1-.25.25H-1.075a.25.25,0,0,1-.25-.25V-1.075A.25.25,0,0,1-1.075-1.325Zm20.332.5H-.825V14.857H19.257Z"
          transform="translate(2 3.585)"
          fill={color}
        />

        {/* Línea vertical derecha */}
        <path
          d="M-1.537,2.095A.463.463,0,0,1-2,1.632V-1.537A.463.463,0,0,1-1.537-2a.463.463,0,0,1,.463.463V1.632A.463.463,0,0,1-1.537,2.095Z"
          transform="translate(18.529 2)"
          fill={color}
        />
        <path
          d="M-1.537,2.345a.713.713,0,0,1-.713-.713V-1.537a.713.713,0,0,1,.713-.713.713.713,0,0,1,.713.713V1.632A.713.713,0,0,1-1.537,2.345Zm0-4.095a.213.213,0,0,0-.213.213V1.632a.213.213,0,0,0,.213.213.213.213,0,0,0,.213-.213V-1.537A.213.213,0,0,0-1.537-1.75Z"
          transform="translate(18.529 2)"
          fill={color}
        />

        {/* Línea vertical central */}
        <path
          d="M-1.537,2.095A.463.463,0,0,1-2,1.632V-1.537A.463.463,0,0,1-1.537-2a.463.463,0,0,1,.463.463V1.632A.463.463,0,0,1-1.537,2.095Z"
          transform="translate(12.754 2)"
          fill={color}
        />
        <path
          d="M-1.537,2.345a.713.713,0,0,1-.713-.713V-1.537a.713.713,0,0,1,.713-.713.713.713,0,0,1,.713.713V1.632A.713.713,0,0,1-1.537,2.345Zm0-4.095a.213.213,0,0,0-.213.213V1.632a.213.213,0,0,0,.213.213.213.213,0,0,0,.213-.213V-1.537A.213.213,0,0,0-1.537-1.75Z"
          transform="translate(12.754 2)"
          fill={color}
        />

        {/* Línea vertical izquierda */}
        <path
          d="M-1.537,2.095A.463.463,0,0,1-2,1.632V-1.537A.463.463,0,0,1-1.537-2a.463.463,0,0,1,.463.463V1.632A.463.463,0,0,1-1.537,2.095Z"
          transform="translate(6.979 2)"
          fill={color}
        />
        <path
          d="M-1.537,2.345a.713.713,0,0,1-.713-.713V-1.537a.713.713,0,0,1,.713-.713.713.713,0,0,1,.713.713V1.632A.713.713,0,0,1-1.537,2.345Zm0-4.095a.213.213,0,0,0-.213.213V1.632a.213.213,0,0,0,.213.213.213.213,0,0,0,.213-.213V-1.537A.213.213,0,0,0-1.537-1.75Z"
          transform="translate(6.979 2)"
          fill={color}
        />

        {/* Cuadrícula de días - Fila 1 */}
        <path
          d="M-1.537-2H1.378a.463.463,0,0,1,.463.463V1.378a.463.463,0,0,1-.463.463H-1.537A.463.463,0,0,1-2,1.378V-1.537A.463.463,0,0,1-1.537-2Zm2.452.925h-1.99V.915H.915Z"
          transform="translate(5.521 8.419)"
          fill={color}
        />
        <path
          d="M-1.537-2.25H1.378a.713.713,0,0,1,.713.713V1.378a.713.713,0,0,1-.713.713H-1.537a.713.713,0,0,1-.713-.713V-1.537A.713.713,0,0,1-1.537-2.25ZM1.378,1.59a.213.213,0,0,0,.213-.213V-1.537a.213.213,0,0,0-.213-.213H-1.537a.213.213,0,0,0-.213.213V1.378a.213.213,0,0,0,.213.213ZM-1.075-1.325H.915a.25.25,0,0,1,.25.25V.915a.25.25,0,0,1-.25.25h-1.99a.25.25,0,0,1-.25-.25v-1.99A.25.25,0,0,1-1.075-1.325Zm1.74.5H-.825V.665H.665Z"
          transform="translate(5.521 8.419)"
          fill={color}
        />

        {/* Cuadrícula de días - Fila 2 */}
        <path
          d="M-1.537-2H1.378a.463.463,0,0,1,.463.463V1.378a.463.463,0,0,1-.463.463H-1.537A.463.463,0,0,1-2,1.378V-1.537A.463.463,0,0,1-1.537-2Zm2.452.925h-1.99V.915H.915Z"
          transform="translate(5.521 14.226)"
          fill={color}
        />
        <path
          d="M-1.537-2.25H1.378a.713.713,0,0,1,.713.713V1.378a.713.713,0,0,1-.713.713H-1.537a.713.713,0,0,1-.713-.713V-1.537A.713.713,0,0,1-1.537-2.25ZM1.378,1.59a.213.213,0,0,0,.213-.213V-1.537a.213.213,0,0,0-.213-.213H-1.537a.213.213,0,0,0-.213.213V1.378a.213.213,0,0,0,.213.213ZM-1.075-1.325H.915a.25.25,0,0,1,.25.25V.915a.25.25,0,0,1-.25.25h-1.99a.25.25,0,0,1-.25-.25v-1.99A.25.25,0,0,1-1.075-1.325Zm1.74.5H-.825V.665H.665Z"
          transform="translate(5.521 14.226)"
          fill={color}
        />

        {/* Columna central - Fila 1 */}
        <path
          d="M-1.537-2H1.378a.463.463,0,0,1,.463.463V1.378a.463.463,0,0,1-.463.463H-1.537A.463.463,0,0,1-2,1.378V-1.537A.463.463,0,0,1-1.537-2Zm2.452.925h-1.99V.915H.915Z"
          transform="translate(11.296 8.419)"
          fill={color}
        />
        <path
          d="M-1.537-2.25H1.378a.713.713,0,0,1,.713.713V1.378a.713.713,0,0,1-.713.713H-1.537a.713.713,0,0,1-.713-.713V-1.537A.713.713,0,0,1-1.537-2.25ZM1.378,1.59a.213.213,0,0,0,.213-.213V-1.537a.213.213,0,0,0-.213-.213H-1.537a.213.213,0,0,0-.213.213V1.378a.213.213,0,0,0,.213.213ZM-1.075-1.325H.915a.25.25,0,0,1,.25.25V.915a.25.25,0,0,1-.25.25h-1.99a.25.25,0,0,1-.25-.25v-1.99A.25.25,0,0,1-1.075-1.325Zm1.74.5H-.825V.665H.665Z"
          transform="translate(11.296 8.419)"
          fill={color}
        />

        {/* Columna central - Fila 2 */}
        <path
          d="M-1.537-2H1.378a.463.463,0,0,1,.463.463V1.378a.463.463,0,0,1-.463.463H-1.537A.463.463,0,0,1-2,1.378V-1.537A.463.463,0,0,1-1.537-2Zm2.452.925h-1.99V.915H.915Z"
          transform="translate(11.296 14.226)"
          fill={color}
        />
        <path
          d="M-1.537-2.25H1.378a.713.713,0,0,1,.713.713V1.378a.713.713,0,0,1-.713.713H-1.537a.713.713,0,0,1-.713-.713V-1.537A.713.713,0,0,1-1.537-2.25ZM1.378,1.59a.213.213,0,0,0,.213-.213V-1.537a.213.213,0,0,0-.213-.213H-1.537a.213.213,0,0,0-.213.213V1.378a.213.213,0,0,0,.213.213ZM-1.075-1.325H.915a.25.25,0,0,1,.25.25V.915a.25.25,0,0,1-.25.25h-1.99a.25.25,0,0,1-.25-.25v-1.99A.25.25,0,0,1-1.075-1.325Zm1.74.5H-.825V.665H.665Z"
          transform="translate(11.296 14.226)"
          fill={color}
        />

        {/* Columna derecha - Fila 1 */}
        <path
          d="M-1.537-2H1.378a.463.463,0,0,1,.463.463V1.378a.463.463,0,0,1-.463.463H-1.537A.463.463,0,0,1-2,1.378V-1.537A.463.463,0,0,1-1.537-2Zm2.452.925h-1.99V.915H.915Z"
          transform="translate(17.071 8.419)"
          fill={color}
        />
        <path
          d="M-1.537-2.25H1.378a.713.713,0,0,1,.713.713V1.378a.713.713,0,0,1-.713.713H-1.537a.713.713,0,0,1-.713-.713V-1.537A.713.713,0,0,1-1.537-2.25ZM1.378,1.59a.213.213,0,0,0,.213-.213V-1.537a.213.213,0,0,0-.213-.213H-1.537a.213.213,0,0,0-.213.213V1.378a.213.213,0,0,0,.213.213ZM-1.075-1.325H.915a.25.25,0,0,1,.25.25V.915a.25.25,0,0,1-.25.25h-1.99a.25.25,0,0,1-.25-.25v-1.99A.25.25,0,0,1-1.075-1.325Zm1.74.5H-.825V.665H.665Z"
          transform="translate(17.071 8.419)"
          fill={color}
        />

        {/* Columna derecha - Fila 2 */}
        <path
          d="M-1.537-2H1.378a.463.463,0,0,1,.463.463V1.378a.463.463,0,0,1-.463.463H-1.537A.463.463,0,0,1-2,1.378V-1.537A.463.463,0,0,1-1.537-2Zm2.452.925h-1.99V.915H.915Z"
          transform="translate(17.071 14.226)"
          fill={color}
        />
        <path
          d="M-1.537-2.25H1.378a.713.713,0,0,1,.713.713V1.378a.713.713,0,0,1-.713.713H-1.537a.713.713,0,0,1-.713-.713V-1.537A.713.713,0,0,1-1.537-2.25ZM1.378,1.59a.213.213,0,0,0,.213-.213V-1.537a.213.213,0,0,0-.213-.213H-1.537a.213.213,0,0,0-.213.213V1.378a.213.213,0,0,0,.213.213ZM-1.075-1.325H.915a.25.25,0,0,1,.25.25V.915a.25.25,0,0,1-.25.25h-1.99a.25.25,0,0,1-.25-.25v-1.99A.25.25,0,0,1-1.075-1.325Zm1.74.5H-.825V.665H.665Z"
          transform="translate(17.071 14.226)"
          fill={color}
        />
      </g>
    </svg>
  );
};
